export default "__VITE_ASSET__DsCftEwO__"